import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuerySample } from '@store/helpers';
import { DEFAULT_PAGE_SIZE } from '@src/utils/constants';

export const auditLogsApi = createApi({
  reducerPath: 'AuditLogs',
  tagTypes: ['AuditLogs'],
  baseQuery: baseQuerySample,
  endpoints: (builder) => ({
    getAuditView: builder.mutation({
      query: ({ argument: { id }, params = {}, body = {} }) => ({
        url: `/v1/logs/audit/view/${id}`,
        method: 'POST',
        body,
        params: {
          sortBy: 'timestamp',
          sortDir: 'desc',
          page: 0,
          size: DEFAULT_PAGE_SIZE,
          ...params,
        },
      }),
    }),

    getAdminUserLogs: builder.mutation({
      query: ({ argument: { id }, params = {}, body = {} }) => ({
        url: `/v1/logs/audit/user-modification/${id}`,
        method: 'POST',
        body,
        params: {
          sortBy: 'actionTime',
          sortDir: 'desc',
          page: 0,
          size: DEFAULT_PAGE_SIZE,
          ...params,
        },
      }),
    }),

    getAdminUserActivity: builder.mutation({
      query: ({ argument: { id }, params = {}, body = {} }) => ({
        url: `/v1/logs/audit/modification/${id}`,
        method: 'POST',
        body,
        params: {
          sortBy: 'actionTime',
          sortDir: 'desc',
          page: 0,
          size: DEFAULT_PAGE_SIZE,
          ...params,
        },
      }),
    }),

    // getLogs: builder.query({
    //   query: ({ params = {}, argument: { type, resource, recordId } }) => ({
    //     url: `/v1/logs/audit/modification/${type}/${resource}/${recordId}`,
    //     params: {
    //       sortBy: 'actionTime',
    //       sortDir: 'desc',
    //       page: 0,
    //       size: DEFAULT_PAGE_SIZE,
    //       ...params,
    //     },
    //   }),
    // }),

    getLogs: builder.mutation({
      query: ({
        params = {},
        argument: { type, resource, recordId },
        body = {},
      }) => ({
        url: `/v1/logs/audit/modification/${type}/${resource}/${recordId}`,
        method: 'POST',
        body,
        params: {
          sortBy: 'actionTime',
          sortDir: 'desc',
          page: 0,
          size: DEFAULT_PAGE_SIZE,
          ...params,
        },
      }),
    }),

    getUserLogins: builder.mutation({
      query: ({ argument: { email }, params = {}, body = {} }) => ({
        url: `/v1/logs/audit/login-log/${email}`,
        method: 'POST',
        body,
        params: {
          sortBy: 'timestamp',
          sortDir: 'desc',
          page: 0,
          size: DEFAULT_PAGE_SIZE,
          ...params,
        },
      }),
    }),

    getModificationHistory: builder.mutation({
      query: ({ argument: { type }, body = {}, params = {} }) => ({
        url: `/v1/logs/audit/modification/model/${type}`,
        method: 'POST',
        body,
        params: {
          sortBy: 'actionTime',
          sortDir: 'desc',
          page: 0,
          size: DEFAULT_PAGE_SIZE,
          ...params,
        },
      }),
    }),

    getRecordViewHistory: builder.mutation({
      query: ({ argument: { type }, body = {}, params = {} }) => ({
        url: `/v1/logs/audit/views/${type}`,
        method: 'POST',
        body,
        params: {
          sortBy: 'timestamp',
          sortDir: 'desc',
          page: 0,
          size: DEFAULT_PAGE_SIZE,
          ...params,
        },
      }),
    }),

    updateLogs: builder.mutation({
      query: (updateData) => ({
        url: '/documents', // Endpoint for updating documents
        method: 'POST', // HTTP method for updating
        body: updateData, // Data to send with the request
      }),
    }),

    getPortalLogs: builder.query({
      query: ({ params = {} }: { params?: Record<string, unknown> } = {}) => ({
        url: '/v2/logs/modification/contractor-portal',
        params: {
          sortBy: 'actionTime',
          sortDir: 'desc',
          page: 0,
          size: 7,
          ...params,
        },
      }),
    }),
  }),
});

export const {
  useGetAuditViewMutation,
  useGetAdminUserLogsMutation,
  useGetAdminUserActivityMutation,
  useGetUserLoginsMutation,
  useGetLogsMutation,
  useGetModificationHistoryMutation,
  useGetRecordViewHistoryMutation,
  useUpdateLogsMutation,
  useLazyGetPortalLogsQuery,
} = auditLogsApi;
